/* global FileReader */

import React, { Component } from 'react'
import css from './styles.scss'
import { connect } from 'react-redux'
import globalCss from '../../../scss/global.scss'
import { createDataSource, editDataSource } from '../../actions/actions'
import uuidv4 from 'uuid/v4'

export class AddDataSource extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: false,
      loading: false,
      connected: true,
      name: '',
      type: '',
      promoted: '',
      sources: [],
      data: [],
      toggle: false
    }
  }

  componentDidMount () {
    document.addEventListener('click', this.closeDropDown)
  }

  componentWillUnmount () {
    document.removeEventListener('click', this.closeDropDown)
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.modal === 'newSource' && nextProps.modal !== 'newSource') {
      this.closeModal()
    }
  }

  closeDropDown = evt => {
    const { toggle } = this.state
    const notDropDown = evt.target.getAttribute('id') !== 'newDsToggle'
    if (toggle && notDropDown) {
      this.handleOptions()
    }
  }

  handleOptions = () => {
    this.setState(prevState => ({ toggle: !prevState.toggle }))
  }

  fetchDataSources () {
    return fetch('/api/v1/data_sources?include=id,name', {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.props.auth.bearerToken}`
      }
    })
      .then(res => {
        if (res.status === 200) {
          return res.json()
        }
        return {
          _error: res.statusText
        }
      }).then(data => {
        if (data._error) {
          return false
        }

        return data.results
      }).catch(() => {
        this.setState({
          connected: false
        })
      })
  }

  openModal = () => {
    this.setState({
      loading: true
    }, () => {
      this.fetchDataSources().then(dataSources => {
        this.setState({
          sources: dataSources,
          loading: false,
          showModal: true
        })
      })
    })
  }

  closeModal = (backToItem = false) => {
    this.setState({
      showModal: false,
      loading: false,
      rows: [],
      data: [],
      name: '',
      type: '',
      promoted: ''
    })
    if (backToItem) {
      this.props.onClearModal()
    }
  }

  handleInput = evt => {
    this.setState({
      [evt.target.name]: evt.target.value
    })
  }

  handleUpdatePromoted = evt => {
    if (!evt.target.value) {
      this.setState({
        promoted: ''
      })
    } else {
      this.setState({
        promoted: evt.target.value
      })
    }
  }

  handleCreate = () => {
    const { data } = this.state
    const name = 'unnamed'
    const id = uuidv4()
    const columns = data.length ? Object.keys(data[0]) : []
    const body = {
      id,
      name,
      data,
      columns,
      modifiedAt: ''
    }
    this.props.dispatch(createDataSource(body))
    this.props.dispatch(editDataSource(id))
    this.props.onHandleModal(null, false, true)
    this.closeModal()
  }

  handleCreateFromPromoted = () => {
    const { promoted, creating } = this.state

    if (creating) return

    this.setState({ creating: true })
    this.fetchDataSourceById(promoted).then(source => {
      const body = {
        id: source.id,
        name: source.name,
        data: source.data,
        tags: source.tags,
        columns: source.columns
      }

      this.setState({ creating: false })
      this.props.dispatch(createDataSource(body))
      this.props.dispatch(editDataSource(promoted))
      this.props.onHandleModal(null, false, true)
      this.closeModal()
    })
  }

  fetchDataSourceById (id) {
    return fetch(`/api/v1/data_sources/${id}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.props.auth.bearerToken}`
      }
    }).then(res => {
      if (res.status === 200) {
        return res.json()
      }

      return {
        _error: res.statusText
      }
    }).then(data => {
      if (data._error) {
        return false
      }

      return data
    })
  }

  createList = () => {
    const { item: { dataSources, editingDataSource }, app: { primaryColor } } = this.props
    const list = []
    let index = 0
    for (const obj in dataSources) { // eslint-disable-line no-unused-vars
      list.push(
        <li
          key={`_${index}`}
          className={`${css.li} ${obj === editingDataSource ? css.currentTab : null}`}
          style={{ background: obj === editingDataSource ? primaryColor : null }}
          onClick={() => this.editDataSource(dataSources[obj].id)}
          data-modal='editSource'
        >
          {dataSources[obj].name}
        </li>
      )
      index++
    }
    return list
  }

  editDataSource = id => {
    this.props.dispatch(editDataSource(id))
  }

  validateColumns = columns => {
    const invalidNames = columns.some(column => !column.length)
    const duplicateNames = columns.map((column, index) => columns.indexOf(column) !== index).includes(true)
    if (invalidNames || duplicateNames) {
      return true
    } else {
      return false
    }
  }

  handleImportCSV = evt => {
    const file = evt.target.files[0]
    if (!file || !file.name.includes('.csv')) {
      return alert('Error: Invalid file type.')
    }
    const self = this
    const reader = new FileReader()
    reader.onload = function (evt) {
      const splitOnComma = /,(?=(?:(?:[^"]*"){2})*[^"]*$)/
      const removeQuotes = /["']+/g
      const endingDoubleQuotes = /^"(.+(?="$))"$/
      const extraDoubleQuotes = /("+)\1/g
      const result = evt.target.result.split('\n')
      let columns = result[0].split(splitOnComma).map(col => col.replace(removeQuotes, '').trim().slice(0, 50))
      const invalid = self.validateColumns(columns)
      if (invalid) {
        return alert('Error: Column names are invalid.')
      }
      if (columns.length > 50) {
        columns = columns.slice(0, 50)
      }
      const rows = result.slice(1, 10000).filter(row => {
        if (row.trim().replace(/,/g, '')) {
          return true
        } else {
          return false
        }
      })
      const data = rows.map(row => {
        const values = row.split(splitOnComma)
        const obj = {}
        for (let i = 0; i < columns.length; i++) {
          const cell = values[i].trim()
            .replace(endingDoubleQuotes, '$1')
            .replace(extraDoubleQuotes, "$1")
          obj[columns[i]] = cell
        }
        return obj
      })
      if (!data.length) {
        return alert("Error: There aren't any rows.")
      }
      self.setState({
        data
      })
    }
    reader.readAsText(file)
  }

  promotedOptions = () => {
    const { promoted, sources } = this.state
    const options = sources.map((source, index) => {
      return <option value={source.id} key={`_${index}`}>{source.name}</option>
    })
    return (
      <div className={`${css.dropdownBacker} ${css.dropdownExtra}`}>
        <select className={css.select} value={promoted} onChange={this.handleUpdatePromoted}>
          <option value=''>Choose From Promoted Data Sources...</option>
          {options}
        </select>
      </div>
    )
  }

  getOptions = () => {
    const { type } = this.state
    switch (type) {
      case 'manual':
        return <button onClick={this.handleCreate} className={css.create}>Create</button>
      case 'csv':
        return (
          <div>
            <input type='file' onChange={this.handleImportCSV} className={css.upload} />
            <div className={css.importText}>
              <ul>
                <li>Column names must be unique and can be up to 50 characters long.</li>
                <li>Only supports a maximum of 10,000 rows and 50 columns.</li>
              </ul>
            </div>
          </div>
        )
      case 'promoted':
        return this.promotedOptions()
      default:
        return null
    }
  }

  handleChooseSource = evt => {
    const type = evt.target.getAttribute(['data-source'])
    if (type === 'manual') {
      this.handleCreate()
    } else {
      this.setState({
        type,
        data: [],
        promoted: ''
      })
      this.openModal()
    }
  }

  render () {
    let modal
    let loadingView
    const { showModal, loading, type, promoted, data, creating, toggle } = this.state
    const { app: { primaryColor } } = this.props

    const sourceOptions = this.getOptions()
    const dataSourceList = this.createList()
    if (loading) {
      loadingView = (
        <div className={css.bg}>
          <article className={css.wrapper}>
            <header className={css.header}>
              <h3 className={css.h3}>
              Loading...
              </h3>
            </header>
            <div className={css.content}>
              <i className={`${globalCss.iconSpin4} ${globalCss.animateSpin}`} />
            </div>
          </article>
        </div>
      )
    }

    let createText = 'Create'
    if (creating) createText = 'Creating...'

    let createButton
    if (promoted && type === 'promoted') {
      createButton = (<button onClick={this.handleCreateFromPromoted} className={css.create}>{createText}</button>)
    }

    if (data.length && type === 'csv') {
      createButton = (<button onClick={this.handleCreate} className={css.create}>Create</button>)
    }

    if (showModal) {
      modal = (
        <div className={css.bg}>
          <article className={css.wrapper}>
            <header className={css.header}>
              <h3 className={css.h3}>
              Create New Data Source
              </h3>
              <h2 className={css.h2}>{type === 'csv' ? 'Import from CSV' : 'Promoted Data Source'}</h2>
            </header>
            <div className={css.content}>
              {sourceOptions}
              {createButton}
            </div>
          </article>
        </div>
      )
    }
    return (
      <div>
        <div style={{ position: 'relative' }}>
          <button
            type='button'
            className={`${css.btn} ${toggle || this.props.modal === 'newSource' ? css.currentTab : null}`}
            onClick={this.handleOptions}
            style={{ background: toggle || this.props.modal === 'newSource' ? primaryColor : null }}
            id='newDsToggle'
          >
            Data Sources <i className={`${css.btnAdd}`}>{toggle ? '-' : '+'}</i>
          </button>
          <div className={css.optionList} style={{ visibility: toggle ? 'visible' : 'hidden' }} onClick={this.handleChooseSource}>
            <button className={css.btn} data-source='manual'>Manual</button>
            <button className={css.btn} data-modal='newSource' data-source='csv'>Import from CSV</button>
            <button className={css.btn} data-modal='newSource' data-source='promoted'>Promoted Data Source</button>
          </div>
        </div>
        <ul className={css.ul}>
          {dataSourceList}
        </ul>
        {loadingView}
        {modal}
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { app, auth, item, templates } = state
  return {
    app,
    auth,
    item,
    templates
  }
}

export default connect(mapStateToProps)(AddDataSource)



// WEBPACK FOOTER //
// /app/js/components/NewDataSource/index.js